// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__G61qS","bw":"styles_bw__om7rk"};